import { CustomStep } from "../warehouseJoyrideSteps";
import JoyrideTooltip from "../../JoyrideTooltip/JoyrideTooltip";
import JoyrideTooltipContentWrapper from "../components/JoyrideTooltipContentWrapper";
import { WarehouseTutorialType } from "../../../../utils/enums";
import SimpleContentStep from "../StepsComponents/SimpleContentStep";
import React from "react";
import CreateProductFormStep from "../StepsComponents/CreateProductFormStep";
import TutorialTransStep from "../StepsComponents/TutorialTransStep";

export const getConsumablesWriteOffConfigArray = (
    branchId: string,
    currentCompanyId: string,
    hasSelectedServices?: boolean,
    hasProducts?: boolean,
    goNext?: () => void
): CustomStep[] => {
    const windowWidth = window?.innerWidth;

    return [
        // step 0
        {
            target: "[data-tour='create-product-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper
                        hasProducts={hasProducts}
                        skipCreateProductRout={`/warehouse/technological-maps/${currentCompanyId}/branch/${branchId}`}
                    >
                        <SimpleContentStep text='Click the "Add product" button' fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
        },
        // step 1
        {
            target: "[data-tour='create-product-form']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <CreateProductFormStep />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1780 ? "left" : "top",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            isFixed: true,
            observeResize: true,
            pageScrollReposition: true,
            disableScrollParentFix: false,
        },
        // step 2
        {
            target: "[data-tour='product-created']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper
                        showNext
                        route={`/warehouse/technological-maps/${currentCompanyId}/branch/${branchId}`}
                    >
                        <SimpleContentStep text="The product has been created!" fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
        },
        // step 3
        {
            target: "[data-tour='create-tech-map-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="createTechMapBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
        },
        // step 4
        {
            target: "[data-tour='create-tech-map-form']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep
                            translationKey="createTechMapForm"
                            icon={
                                <span>
                                    {" "}
                                    (<span className="text-danger">*</span>){" "}
                                </span>
                            }
                        />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "top",
            floaterProps: {
                placement: "top",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            offset: 0,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 5
        {
            target: "[data-tour='products-tech-map-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="productsTechMapBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 6,
        },
        // step 6
        {
            target: "[data-tour='add-products-to-tech-map-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="addProductsToTechMapBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 7
        {
            target: "[data-tour='add-product-to-tech-map']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="addProductToTechMap" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 8
        {
            target: "[data-tour='added-product-to-tech-map']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext>
                        <SimpleContentStep text="Products added to Tech map" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
        },
        // step 9
        {
            target: "[data-tour='edit-quantity-product-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="editQuantityProductBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 6,
        },
        // step 10
        {
            target: "[data-tour='edit-quantity-product-inputs']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep
                            translationKey="editQuantityProductInputs"
                            icon={<i className="fw-bold"> "✔" </i>}
                        />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom-end",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        //  if there are services then jump to 15
        // step 11
        {
            target: "[data-tour='to-services-tech-map-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="toServicesTechMapBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 12
        {
            target: "[data-tour='create-service-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <SimpleContentStep text="Click the “Add service” button" fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 13
        {
            target: "[data-tour='create-service-form']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep
                            translationKey="createServiceForm"
                            icon={
                                <span>
                                    {" "}
                                    (<span className="text-danger">*</span>){" "}
                                </span>
                            }
                        />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 745 ? "left" : "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 14
        {
            target: "[data-tour='created-service']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext>
                        <SimpleContentStep text="The service was created" fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
        },
        // step 15
        {
            target: "[data-tour='choose-service']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext nextEnabled={hasSelectedServices} goNext={goNext}>
                        <SimpleContentStep text="On the right are marked services that will be associated with the technological map." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1780 ? "left" : "top",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            headroomRules: [{ maxW: 1780, top: 70 }],
        },
        // step 16
        {
            target: "[data-tour='screenshot-modal']",
            headroomTarget: ".screenshot",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNext={goNext}>
                        <SimpleContentStep text="When creating a record for a specific service, technical sheets associated with the service will be automatically added." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 17
        {
            target: "[data-tour='screenshot-modal']",
            headroomTarget: ".screenshot",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNext={goNext}>
                        <SimpleContentStep text="After completing the recording, you can proceed to write off the spent materials." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 18
        {
            target: "[data-tour='screenshot-modal']",
            headroomTarget: ".screenshot",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNext={goNext}>
                        <SimpleContentStep text="The write-off page automatically displays the technical card products that were in the record. You can edit their quantity for write-off, or remove them from the list." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 19
        {
            target: "[data-tour='screenshot-modal']",
            headroomTarget: ".screenshot",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper btnNextTutorial={WarehouseTutorialType.PRODUCT_SALES}>
                        <SimpleContentStep text='You can add other products to the write-off. To complete the write-off, you must click "Confirm write-off"' />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
    ];
};
